import React from 'react';
import '../../global.css';

import Cards from '../Cards';
import HeroSection from '../HeroSection';
import Footer from '../Footer';

function Home() {
  return (
    <>
      <HeroSection />
    </>
  );
}

export default Home;
